// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5957":"bb02c0f2","7270":"1644ddea"}[chunkId] || chunkId) + "." + {"626":"582a8cdd858ab8f8","1963":"3fda34474bc7bea7","5503":"2a05aeb013b26678","5887":"18a46a7dd22ec03d","5957":"d6a7f371a5633b34","7270":"89c5735d4bdd3028"}[chunkId] + ".js";
};